import { AppBar, Box, Button, IconButton, SvgIcon, Toolbar, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { Menu as MenuIcon } from 'react-feather';
import { Link as RouterLink } from 'react-router-dom';
import LanternalLogo from 'src/components/LanternalLogo';
import { THEMES } from 'src/constants';
import useAuth from 'src/hooks/useAuth';
import { ENVIRONMENT, isProductionEnvironment, getApiEnvironment } from '../../../utilities/api-config';
import Account from './Account';
import Settings from './Settings';
import Alerts from './Alerts';
import useIsClientView from 'src/hooks/useIsClientView';

const TopBar = ({ className, onNavOpen = () => {}, ...rest }) => {
  const { isAuthenticated, loginWithRedirect } = useAuth();
  const isClientView = useIsClientView();

  const getTopBarText = () => {
    if (isProductionEnvironment()) {
      return 'Lantern';
    }

    return 'Lantern ' + ENVIRONMENT + ' - ' + 'API Environment: ' + getApiEnvironment();
  };

  return (
    <AppBar
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 100,
        ...(isProductionEnvironment()
          ? {
              backgroundColor: (theme) =>
                theme.name === THEMES.LIGHT
                  ? theme.palette.header.dark
                  : theme.name === THEMES.DARK
                    ? theme.palette.background.default
                    : undefined,
            }
          : {
              backgroundColor: (theme) =>
                getApiEnvironment() === 'Production' ? theme.palette.warning.main : theme.palette.text.secondary,
            }),
      }}
      className={className}
      {...rest}
    >
      <Toolbar
        disableGutters
        sx={{
          minHeight: 52,
          paddingLeft: '15px',
          paddingRight: '15px',
        }}
      >
        {!isClientView && (
          <IconButton style={{ marginRight: '20px', color: 'white' }} onClick={onNavOpen} size="large">
            <SvgIcon fontSize="small">
              <MenuIcon />
            </SvgIcon>
          </IconButton>
        )}
        <Box display="flex" flexDirection="row" alignItems="center">
          <Box
            pr={2}
            sx={{
              marginTop: '4px',
              marginRight: 2,
            }}
          >
            {!isClientView ? (
              <RouterLink to="/">
                <LanternalLogo environment={getApiEnvironment()} />
              </RouterLink>
            ) : (
              <LanternalLogo environment={getApiEnvironment()} />
            )}
          </Box>
          <Box p={1}>
            <Typography variant="h4" color="white">
              {getTopBarText()}
            </Typography>
          </Box>
        </Box>
        <Box ml={2} flexGrow={1} />
        {!isClientView && isAuthenticated && <Alerts />}
        <Settings />
        {!isClientView && isAuthenticated && (
          <Box ml={2}>
            <Account />
          </Box>
        )}
        {!isClientView && !isAuthenticated && (
          <Box ml={2}>
            <Button onClick={() => loginWithRedirect()} color="inherit">
              Login
            </Button>
          </Box>
        )}
      </Toolbar>
    </AppBar>
  );
};

TopBar.propTypes = {
  className: PropTypes.string,
  onNavOpen: PropTypes.func,
};

export default TopBar;
